import { useEffect } from 'react';

// @mui
import { Box, Grid, Container, Typography } from '@mui/material';
// components
import HeaderBreadcrumbs from '../../components/header-breadcrumbs';
import { Widget404, LoadSkeleton } from '../../components/widegts';
import Markdown from '../../components/markdown';
import { Seo } from '../../components/seo';

// redux
import { useDispatch, useSelector } from '../../redux/store';

// data
import { getCms } from '../../redux/slices/cms';

// ----------------------------------------------------------------------

export default function RefundPage() {
  const dispatch = useDispatch();
  const { cms, error, isLoading } = useSelector((state) => state.cms);
  const pageTitle = 'Refund Policy';

  useEffect(() => {
    dispatch(getCms('rf'));
  }, [dispatch]);

  return (
    <>
      <Seo
        title={pageTitle}
        description="Read the ASAP UAE refund policy for courses, learning services and eligible purchases, including request conditions and the review process."
        path="/refund"
      />

      {!cms && isLoading ? (
        <LoadSkeleton />
      ) : !cms && error ? (
        <Widget404 item={pageTitle} subitem={`No data found for ${pageTitle}`} />
      ) : !cms ? (
        <LoadSkeleton />
      ) : (
      <Container maxWidth="xl">
        <HeaderBreadcrumbs
          heading={pageTitle}
          links={[
            {
              name: 'Home',
              href: '/',
            },
            { name: `${pageTitle}` },
          ]}
        />

        <Grid container spacing={3}>
          <Grid size={{ xs: 12 }}>
            <Box sx={{ p: { xs: 3, md: 5 } }}>
              <Typography variant="h6" sx={{ mb: 5 }}>
                {pageTitle}
              </Typography>

              <Markdown children={cms.content} />
            </Box>
          </Grid>
        </Grid>
      </Container>
      )}
    </>
  );
}
